import React, { useState, useRef } from "react"
import axios from 'axios'

function Login(props){
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [errorMessage, setErrorMessage] = useState('')

  const usernameInput = useRef(null)
  const passwordInput = useRef(null)

  const submitForm = () => {
    if(username === '' || password === ''){
      setErrorMessage('Fields not set')
    } else {
      setErrorMessage('')
      const formData = new FormData()
      formData.append('username', username)
      formData.append('password', password)

      const endpoint = '/login'
      axios.post(endpoint, formData, { withCredentials: true } ).then(res => {
        console.log('response returned: ')
        console.log(res.status)
        window.location.href = '/apps'
      }).catch(err => {
        console.log(err)
        // if it returns then it didn't succeed so...
        setPassword('')
        passwordInput.value = ''
        setErrorMessage('No user exists with that combination')
      })
    }
  }

  return(
    <div>
      <div>
        <div className="form-modal">
          <h1>Login</h1>
          <p className='error-message'><b><i>{errorMessage}</i></b></p>
          <p><input ref={usernameInput} type="text" value={username} placeholder="username" onChange={e => setUsername(e.target.value)}></input></p>
          <p><input ref={passwordInput} type="password" value={password} placeholder="password" onChange={e => setPassword(e.target.value)}></input></p>
          <p><input type='submit' value='Submit' onClick={submitForm} /></p>
        </div>
      </div>

    </div>
  )
}

export default Login;
